<template lang="pug">
  DataTablePageNew(
    ref="dataQuery"
    mainColumn=""
    longColumn=""
    title="月用水波动分析"
    :resource="resource"
    :operation="operation"
    :operationWidth="80"
    :tableFullList="tableFullList"
    :tableInitList="tableInitList"
    :filterFullList="filterFullList"
    :filterInitList="filterInitList"
    :columns="columns")
</template>
<script>
import DataTablePageNew from '@/containers/DataTablePage/defined'
import columns from './waterColumns.js'
import { expire } from '@/utils/auth'
export default {
  name: 'MonthAnalysis',
  components: {
    DataTablePageNew
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
  },
  data () {
    return {
      resource: '/meterPayload/history/allMonthWave',
      successData: 0,
      faildData: 0,
      operation: [{
        label: '查看历史数据',
        icon: 'meterRecords',
        tooltip: true,
        func ({funcProps}) {
          const { data } = funcProps
          this.$router.push({
            path: `/telnetReading/dataQueryHistory/${data.counterId}`
          })
        }
      }],
      tableInitList: ['hno', 'hname', 'phone', 'mobile', 'addr', 'counterCode', 'areaPathName', 'cost'],
      tableFullList: ['hno', 'hname', 'phone', 'mobile', 'addr', 'counterCode', 'areaPathName', 'cost'],
      filterInitList: ['aTime', 'bTime', 'areaId'],
      filterFullList: ['aTime', 'bTime', 'areaId'],
      columns: {
        ...columns,
        aTime: {
          label: '选择对比月份',
          // type: 'date',
          // dataType: 'number',
          filter: {
            type: 'date',
            width: 105,
            placeholder: '选择月份',
            dateType: 'month'
          }
        },
        bTime: {
          label: '-',
          type: 'date',
          filter: {
            type: 'date',
            width: 105,
            placeholder: '选择月份',
            dateType: 'month'
          }
        },
        wavePercent: {
          label: '波动百分比',
          filter: {
            width: 100,
            type: 'input',
            suffix: {
              type: 'default',
              text: '%'
            },
            rules: [{ type: 'required', message: '请填写波动百分比' },
             { type: 'mixNumfloat', message: '只允许输入整数、浮点数' }]
          }
        },
        areaId: {
          label: '区域',
          relation: 'areaId',
          type: 'select',
          width: 150,
          filter: {
            type: 'cascader',
            width: 120,
            like: true,
            onlySelectLeaf: false,
            rules: [{ type: 'required', message: '请选择对应的区域' }]
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// MonthAnalysis.vue?c250c33a